import { RESPONSE } from '@factories/vasApiResponseConstants'
import { getTotalUnpaidAmountChallan, getUnpaidChallan } from '@components/MainWidget/common/helper'
import { CHALLAN_API } from '@components/MainWidget/ChallanWidget/challanConstants'

export const ChallanService = async ({ regNo, setChallanAmount, setChallanLength }) => {
    fetch(CHALLAN_API(regNo))
      .then(res => {
        if (!res.ok) {
          throw new Error(`${RESPONSE.ERROR_HTTP} ${res.status}`)
        }
        return res.json()
      })
      .then(data => {
        setChallanAmount(getTotalUnpaidAmountChallan(data.data))
        setChallanLength(getUnpaidChallan(data.data))
      })
      .catch(e => {
        console.error(RESPONSE.CHALLAN_FETCH_FAIL, e)
      })
}
